import { useStyletron } from "baseui";

import React from "react";
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from "baseui/modal";
import { useDeleteSubscriptionMutation } from "../../../services/resourceGroups/subscriptionApi";
import { useReportMutationState } from "../../../hooks/useReportMutationState";
import { ISubscription } from "@oqdo/automationapps/Memberships/Subscription";

type DeleteDialogProps = {
  subscription: ISubscription;
  isOpen: boolean;
  setIsOpen: any;
};
function DeleteDialog({ subscription, isOpen, setIsOpen }: DeleteDialogProps) {
  const [css, theme] = useStyletron();
  const [del, delResult] = useDeleteSubscriptionMutation();
  useReportMutationState(delResult);

  function close() {
    setIsOpen(false);
  }

  async function deleteRg() {
    await del(subscription.id);
    setIsOpen(false);
  }

  return (
    <React.Fragment>
      <Modal onClose={close} isOpen={isOpen}>
        <ModalHeader>Delete '{subscription.name}'</ModalHeader>
        <ModalBody>
          <>
            Please confirm to delete this Subscription <b>{subscription.name}</b>
          </>
        </ModalBody>
        <ModalFooter>
          <ModalButton kind="tertiary" onClick={close}>
            Cancel
          </ModalButton>
          <ModalButton isLoading={delResult.isLoading} onClick={deleteRg}>
            Okay
          </ModalButton>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
}

export default DeleteDialog;
